import React from 'react'; 

const borderStyle = {
    borderBottom: '1px solid black',
    width: '80%'
}

function Licenses() {
    
      return(
        <div>
            <br />
            <p>Contacts related to the used Open Source components: <a href = "mailto: esignature-sovellustuki@fi.fujitsu.com">esignature-sovellustuki@fi.fujitsu.com</a></p>
            <br />
            {/* -----------------------------------------------------------------------------------*/}
            <h3>React</h3>          {/* Component Name */}
            <p style={borderStyle}>                     {/* Component License Text */}
            MIT License<br />
            <br />
            Copyright (c) Facebook, Inc. and its affiliates.<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in all<br />
            copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE<br />
            SOFTWARE.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-scripts</h3>          {/* Component Name */}
            <p style={borderStyle}>                     {/* Component License Text */}
            MIT License<br />
            <br />
            Copyright (c) Facebook, Inc. and its affiliates.<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in all<br />
            copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE<br />
            SOFTWARE.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-router-dom</h3>          {/* Component Name */}
            <p style={borderStyle}>                     {/* Component License Text */}
            MIT License<br />
            <br />
            Copyright (c) React Training 2016-2018<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in all<br />
            copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE<br />
            SOFTWARE.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-dom</h3>          {/* Component Name */}
            <p style={borderStyle}>                     {/* Component License Text */}
            MIT License<br />
            <br />
            Copyright (c) Facebook, Inc. and its affiliates.<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in all<br />
            copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE<br />
            SOFTWARE.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-cookie</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2015 Benoit Tremblay<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>bootstrap</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2011-2020 Twitter, Inc.<br />
            Copyright (c) 2011-2020 The Bootstrap Authors<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>bootstrap-icons</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2019-2020 The Bootstrap Authors<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-bootstrap-table-next</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-router-bootstrap</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            Apache License <br />
            Version 2.0, January 2004 <br />
            http://www.apache.org/licenses/ <br />
            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-bootstrap</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014-present Stephen J. Collings, Matthew Honnibal, Pieter Vanderwerff<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>i18next</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2017 i18next<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>i18next-http-backend</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            none<br />
            <br />
            Copyright (c) 2020 i18next<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-i18next</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2015 i18next<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>
 
            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-router</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) React Training 2016-2018<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-app-polyfill</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2013-present, Facebook, Inc.<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>axios</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014-present Matt Zabriskie<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>express</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2009-2014 TJ Holowaychuk  &#60;tj&#64;vision-media.ca&#62;<br /> 
            Copyright (c) 2013-2014 Roman Shtylman &#60;shtylman+expressjs&#64;gmail.com&#62;<br />
            Copyright (c) 2014-2015 Douglas Christopher Wilson &#60;doug&#64;somethingdoug.com&#62;<br />
            <br /> 
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>helmet</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2012-2020 Evan Hahn, Adam Baldwin<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>cron</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2012-2018 Dries De Peuter<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>nodemailer</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            <br />
            Copyright (c) 2011-2019 Andris Reinman<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>jsonwebtoken</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2013-2014 Auth0 Inc.<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>cookie-parser</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014 TJ Holowaychuk &#60;tj&#64;vision-media.ca&#62;<br />
            Copyright (c) 2015 Douglas Christopher Wilson &#60;doug&#64;somethingdoug.com&#62;<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>saml2js</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            Copyright 2014 Clever, Inc.<br />
            <br />
            Licensed under the Apache License, Version 2.0 (the "License");<br />
            you may not use this file except in compliance with the License.<br />
            You may obtain a copy of the License at<br />
            <br />
                http://www.apache.org/licenses/LICENSE-2.0<br />
            <br />
            Unless required by applicable law or agreed to in writing, software<br />
            distributed under the License is distributed on an "AS IS" BASIS,<br />
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.<br />
            See the License for the specific language governing permissions and<br />
            limitations under the License.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>formidable</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2011-present Felix Geisendörfer, and contributors.<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>body-parser</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014 Jonathan Ong &#60;me&#64;jongleberry.com&#62;<br />
            Copyright (c) 2014-2015 Douglas Christopher Wilson &#60;doug&#64;somethingdoug.com&#62;<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>pg</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            <br />
            Copyright (c) 2010-2020 Brian Carlson (brian.m.carlson&#64;gmail.com)<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>react-signature-canvas</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            Copyright (c) 2016 Anton Gilgur<br />
            <br />
            Licensed under the Apache License, Version 2.0 (the "License");<br />
            you may not use this file except in compliance with the License.<br />
            You may obtain a copy of the License at<br />
            <br />
                http://www.apache.org/licenses/LICENSE-2.0<br />
            <br />
            Unless required by applicable law or agreed to in writing, software<br />
            distributed under the License is distributed on an "AS IS" BASIS,<br />
            WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.<br />
            See the License for the specific language governing permissions and<br />
            limitations under the License.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>cors</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) React Training 2016-2018<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>dotenv</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            BSD-2-Clause<br />
            <br />
            Copyright (c) 2015, Scott Motte<br />
            All rights reserved.<br />
            <br />
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions are met:

            * Redistributions of source code must retain the above copyright notice, this
              list of conditions and the following disclaimer.

            * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            <br />
            <br />
            THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
            AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
            DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
            FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
            DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
            SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
            OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>gelf-pro</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2013-2019 Kanstantsin Kamkou and contributors<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>calmscan</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2013 Kyle Farris<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>docker-clamav</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) Markus Kosmal<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>concurrently</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2015 Kimmo Brunfeldt<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>
            {/* -----------------------------------------------------------------------------------*/}
            <h3>jasmine</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014-2019 Pivotal Labs<br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>
            {/* -----------------------------------------------------------------------------------*/}
            <h3>nodemon</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2010 - present, Remy Sharp, https://remysharp.com <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>supervisor</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The BSD License<br />
            <br />
            Copyright (c) Isaac Z. Schlueter, Ian Young, and Other Contributors<br />
            All rights reserved.<br />
            <br />
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions are met:

            * Redistributions of source code must retain the above copyright notice, this
              list of conditions and the following disclaimer.

            * Redistributions in binary form must reproduce the above copyright notice,
              this list of conditions and the following disclaimer in the documentation
              and/or other materials provided with the distribution.
            <br />
            <br />
            THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
            ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
            IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
            PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS
            BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
            WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
            OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
            IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.<br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>socket.io-client</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014 Guillermo Rauch <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>

            {/* -----------------------------------------------------------------------------------*/}
            <h3>socket.io</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014-2018 Automattic (dev@cloudup.com) <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p> 
            {/* -----------------------------------------------------------------------------------*/}
            <h3>jest</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) Facebook, Inc. and its affiliates. <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p> 
            {/* -----------------------------------------------------------------------------------*/}
            <h3>@dnd-kit/core</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2021, Claudéric Demers <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>
            {/* -----------------------------------------------------------------------------------*/}
            <h3>supertest</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2014 TJ Holowaychuk (tj@vision-media.ca) <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />            
            </p>   

            {/* -----------------------------------------------------------------------------------*/}
            <h3>@dnd-kit/utilities</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2021, Claudéric Demers <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>
            {/* -----------------------------------------------------------------------------------*/}
            <h3>ajv</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2015-2021 Evgeny Poberezkin <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />            
            </p>  
            {/* -----------------------------------------------------------------------------------*/}
            <h3>@dnd-kit/sortable</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2021, Claudéric Demers <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>
            {/* -----------------------------------------------------------------------------------*/}
            <h3>msw</h3>    {/* Component Name */}
            <p style={borderStyle}>                         {/* Component License Text */}
            The MIT License (MIT)<br />
            <br />
            Copyright (c) 2018–present Artem Zakharchenko <br />
            <br />
            Permission is hereby granted, free of charge, to any person obtaining a copy<br />
            of this software and associated documentation files (the "Software"), to deal<br />
            in the Software without restriction, including without limitation the rights<br />
            to use, copy, modify, merge, publish, distribute, sublicense, and/or sell<br />
            copies of the Software, and to permit persons to whom the Software is<br />
            furnished to do so, subject to the following conditions:<br />
            <br />
            The above copyright notice and this permission notice shall be included in<br />
            all copies or substantial portions of the Software.<br />
            <br />
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR<br />
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,<br />
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE<br />
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER<br />
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,<br />
            OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN<br />
            THE SOFTWARE.            <br />
            </p>                                                                                       
        </div>
);
}


export default Licenses;
